"use client";

import { settings, siteConfig } from "@/app";
import { env } from "@/env.mjs";
import { tv, type VariantProps } from "tailwind-variants";
import { cn } from "@/lib/utils"
import { Suspense } from 'react'
import { Icons } from "@/components/icons";
import { AuthButton } from "@/components/ui/auth-button";
// import { cva, type VariantProps } from "class-variance-authority"


import { useTranslations } from "next-intl";
import { Combobox } from "@/components/navigation/combobox";
import { MainMenu } from "@/components/navigation/main-menu";
import { MobileMenu } from "@/components/navigation/mobile-menu";
// import LocaleSwitcher from "@/components/switchers/localization-main-switcher";
import { ThemesGeneralSwitcher } from "@/components/switchers/themes-general-switcher";
// import { PrimaryButton } from "@/components/ui/primary-button";

import { ButtonPlaceholder } from "../placeholders";
import UserMenu from "./user-menu";
import { Link } from "@/navigation";
import { TheosIcon } from "../icons";

const NavbarStyles = tv({
  // base: "w-full border-b border-transparent bg-background/95",
  base: "w-full border-b border-transparent",
  variants: {
    border: {
      true: "border-border",
    },
    blur: {
      true: "backdrop-blur-md  bg-background/75",
    },
    sticky: {
      true: "sticky top-0 z-50",
    },
    animated: {
      true: "animate-in fade-in slide-in-from-top-full duration-slow",
    },
  },
});

export type SiteHeaderProps = {
  border?: boolean;
  sticky?: boolean;
  blur?: boolean;
} & VariantProps<typeof NavbarStyles>;

export function SiteHeader({
  border = true,
  sticky = true,
  blur = true,
}: SiteHeaderProps) {
  const t = useTranslations('header');

  return (
    <header className={"sticky top-0 z-50 flex items-center py-3 lg:py-[9px]"}>
      <div className="relative z-20 mx-auto flex w-full max-w-7xl items-center justify-between px-5 md:px-8 lg:justify-start">

      <Link
        aria-label="Home"
        href="/"
        className="mr-5 inline-flex shrink-0 rounded lg:mr-7"
      >
        <TheosIcon className="shrink-0 dark:hidden w-20" />
      </Link>
        <MainMenu items={siteConfig.mainNav} />
        <MobileMenu
          MainMenuItems={siteConfig.mainNav}
          sidebarNavItems={siteConfig.mainNav}
        />
        {/* <PrimaryButton>Get started</PrimaryButton> */}
        {/* <AuthButton variant="filled">Get Started</AuthButton>
        <AuthButton variant="outline">Get Started</AuthButton> */}
        {/* <div className="flex flex-1 items-center justify-end space-x-2">
          {settings.themeToggleEnabled && <ThemesGeneralSwitcher />}
     
          {settings.internationalizationEnabled && <Suspense><LocaleSwitcher /></Suspense>}
          <ButtonPlaceholder text={t('download')} onClick={() => window.open('/blog/get-started', '_self')} />
        </div> */}
      </div>
      <div className="pointer-events-none absolute top-0 z-10 h-20 w-full bg-[linear-gradient(180deg,rgba(221,226,238,0.40)_0%,rgba(221,226,238,0.00)_100%)] mask-[linear-gradient(to_bottom,black_65%,rgba(0,0,0,0.88)_75%,transparent_100%)] backdrop-blur-2xl" aria-hidden="true"></div>
    </header>
  );
}
